var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-text c-container c-container--big",attrs:{"data-anim":"lineText"}},[_c('h3',{staticClass:"line-text__title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"line-text__line"})])}
var staticRenderFns = []

export { render, staticRenderFns }